import { call, put, takeLatest } from "redux-saga/effects";
import { samsungWalletRequest, samsungWalletSuccess, samsungWalletFailure } from "../../slice/checkin/samsungSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchSamsungData = async samsungWalletJourney => {
  const MY_SAMSUNG_WALLET_URL = config.MY_SAMSUNG_WALLET_API;
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: false,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const payloadData = {};
  if (samsungWalletJourney?.journeyId?.journeyElementId) {
    payloadData.journeyId = samsungWalletJourney?.journeyId?.journeyId;
    payloadData.journeyElementId = samsungWalletJourney?.journeyId?.journeyElementId;
  } else {
    payloadData.journeyId = samsungWalletJourney?.journeyId?.journeyId;
  }
  if (samsungWalletJourney?.flightNumber?.length > 0) {
    payloadData.flightNumber = samsungWalletJourney?.flightNumber;
  }
  if (samsungWalletJourney?.flightNumber?.length > 0) {
    samsungWalletJourney.flightNumber = samsungWalletJourney?.flightNumber;
  }
  const response = await api.post(`${MY_SAMSUNG_WALLET_URL}`, payloadData, data);
  return response;
};
function* getSamsungData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchSamsungData, payload);
    yield put(samsungWalletSuccess(response.data));
  } catch (error) {
    yield put(samsungWalletFailure(error));
  }
}
export function* watchSamsungWalletData() {
  yield takeLatest(samsungWalletRequest.type, getSamsungData);
}